import { useForm, Controller } from 'react-hook-form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Switch,
  FormControlLabel,
  TextField,
} from '@material-ui/core';
import { makeCall } from 'utils/utils';
import { CreateFormData as FormData, CreateFormPropsType as PropsType } from './types';
import { createDefaultValues as defaultValues } from './initialData';

export default function Create({ open, handleClose, refresh }: PropsType) {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
    reset,
  } = useForm<FormData>({ defaultValues });

  const resetForm = () => {
    reset(defaultValues);
    handleClose();
  };

  const onSubmit = async (data: FormData) => {
    console.log('here');
    const payload = {
      ...data,
    };
    await makeCall('countries', 'POST', payload);
    reset(defaultValues);
    handleClose();
    refresh();
  };
  return (
    <Dialog
      open={open}
      disableBackdropClick={true}
      onEscapeKeyDown={resetForm}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Create New Country</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {/* <EnhancedTextField
            control={control}
            required={true}
            fieldName="countryCode"
            label="Country code"
            hasError={errors.countryCode ? true : false}
            errorTxt="Country Code is required!"
            autoFocus
          /> */}
          <Controller
            render={({ field }) => (
              <TextField
                {...field}
                error={errors.countryCode ? true : false}
                helperText={errors.countryCode ? 'Country Code is required!' : null}
                autoFocus
                margin="dense"
                label="Country code"
                fullWidth
              />
            )}
            name="countryCode"
            control={control}
            rules={{ required: true }}
          />
          <Controller
            render={({ field }) => (
              <TextField
                {...field}
                error={errors.countryName ? true : false}
                helperText={errors.countryName ? 'Country name is required!' : null}
                margin="dense"
                label="Country name"
                fullWidth
              />
            )}
            name="countryName"
            control={control}
            rules={{ required: true }}
          />
          {/* <EnhancedTextField
            control={control}
            required={true}
            fieldName="countryName"
            label="Country name"
            hasError={errors.countryName ? true : false}
            errorTxt="Country name is required!"
          /> */}
          <Controller
            name="countryStatus"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <FormControlLabel control={<Switch defaultChecked {...field} color="primary" />} label="Active" />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={resetForm} color="primary">
            Cancel
          </Button>
          <Button disabled={isSubmitting} type="submit" color="primary">
            {isSubmitting ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
